<div class="flex-col flex">
    <div class="mat-subtitle-1 widget-name">Documents Requiring Action</div>
    <div class="widget-container flex-col">
        @for (item of data; track item; let i = $index) {
            <div class="widget-list-item flex-col">
                <div class="cb-padding-top cb-padding-bottom start-start flex-row flex">
                    <div class="flex-col flex">
                        <span class="mat-body-2">{{ item.documentType.label }}</span>
                        <span class="mat-caption">{{ item.info }}</span>
                        <span class="mat-caption">{{ item.statusLabel }}</span>
                    </div>
                    <button
                        mat-icon-button
                        class="cb-margin-right"
                        [disabled]="documentEntityViewUrl(item)?.url == '#'"
                        (click)="goToItem(documentEntityViewUrl(item), $event)"
                    >
                        <mat-icon>pageview</mat-icon>
                    </button>
                </div>
                @if (i < data.length - 1) {
                    <hr class="mat-divider" />
                }
            </div>
        }
        @if (!data || !data.length) {
            <span class="start-center flex layoutGap-6">
                <mat-icon class="mat-accent">info_circle</mat-icon>
                <div>There are no Documents requiring action</div>
            </span>
        }
    </div>
</div>
